// extracted by mini-css-extract-plugin
export default {"label":"MixedBarChart_label__eUDzg"};